var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M294.643,176.748l-48.214,-0l-0,-75.966c6.215,-2.194 10.714,-8.142 10.714,-15.106c-0,-8.838 -7.233,-16.071 -16.072,-16.071c-8.838,-0 -16.071,7.233 -16.071,16.071c-0,6.964 4.501,12.912 10.714,15.106l0,75.966l-171.428,-0l-0,-75.966c6.215,-2.194 10.714,-8.142 10.714,-15.106c-0,-8.838 -7.233,-16.071 -16.071,-16.071c-8.839,-0 -16.072,7.233 -16.072,16.071c0,6.964 4.501,12.912 10.714,15.106l0,75.966l-48.214,-0c-2.946,-0 -5.357,2.412 -5.357,5.357l-0,64.286c-0,2.945 2.411,5.357 5.357,5.357l289.286,-0c2.946,-0 5.357,-2.412 5.357,-5.357l-0,-64.286c-0,-2.945 -2.411,-5.357 -5.357,-5.357Zm-254.464,50.893c-7.393,-0 -13.393,-6.001 -13.393,-13.393c-0,-7.393 6,-13.393 13.393,-13.393c7.392,-0 13.392,6 13.392,13.393c0,7.392 -6,13.393 -13.392,13.393Zm37.5,-0c-7.393,-0 -13.393,-6.001 -13.393,-13.393c-0,-7.393 6,-13.393 13.393,-13.393c7.392,-0 13.392,6 13.392,13.393c0,7.392 -6,13.393 -13.392,13.393Zm37.5,-0c-7.393,-0 -13.393,-6.001 -13.393,-13.393c-0,-7.393 6,-13.393 13.393,-13.393c7.392,-0 13.392,6 13.392,13.393c0,7.392 -6,13.393 -13.392,13.393Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.571,262.462l-257.142,0l-0,10.714c-0,2.946 2.41,5.358 5.357,5.358l246.428,-0c2.947,-0 5.357,-2.412 5.357,-5.358l0,-10.714Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.423,55.035c-2.129,2.056 -2.189,5.446 -0.136,7.576c2.059,2.129 5.452,2.197 7.576,0.136c12.718,-12.273 33.414,-12.273 46.132,-0c1.038,1.004 2.38,1.501 3.719,1.501c1.402,-0 2.804,-0.549 3.856,-1.638c2.053,-2.129 1.993,-5.519 -0.136,-7.575c-16.82,-16.228 -44.191,-16.228 -61.011,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.666,46.79c21.648,-19.577 56.877,-19.577 78.526,-0c1.025,0.931 2.31,1.386 3.591,1.386c1.462,0 2.919,-0.596 3.976,-1.763c1.985,-2.192 1.816,-5.582 -0.379,-7.564c-25.614,-23.177 -67.289,-23.177 -92.903,-0c-2.194,1.982 -2.364,5.372 -0.379,7.564c1.985,2.187 5.368,2.37 7.568,0.377Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.566,55.035c-2.129,2.056 -2.189,5.446 -0.136,7.576c2.056,2.129 5.452,2.197 7.576,0.136c12.718,-12.273 33.414,-12.273 46.132,-0c1.038,1.004 2.38,1.501 3.719,1.501c1.402,-0 2.804,-0.549 3.856,-1.638c2.053,-2.129 1.993,-5.519 -0.136,-7.575c-16.82,-16.228 -44.191,-16.228 -61.011,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.808,46.79c21.649,-19.577 56.878,-19.577 78.526,-0c1.026,0.931 2.31,1.386 3.592,1.386c1.462,0 2.919,-0.596 3.976,-1.763c1.985,-2.192 1.815,-5.582 -0.379,-7.564c-25.614,-23.177 -67.289,-23.177 -92.903,-0c-2.195,1.982 -2.364,5.372 -0.379,7.564c1.988,2.187 5.368,2.37 7.567,0.377Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlan);
export default __webpack_public_path__ + "static/media/wlan.c0ab2bfd.svg";
export { ForwardRef as ReactComponent };